'use client'

import Link from 'next/link'
import Image from 'next/image'
import classNames from 'classnames'
import { useState } from 'react'

import { NavBarStyle } from './constants'

import styles from './nav-bar.module.scss'

export default function NavigationBar({ style, logo, menuItems, children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const navStyleClassName = () => {
    switch(style) {
      case NavBarStyle.TRANSPARENT:
        return styles["transparent"]
      case NavBarStyle.LIGHT:
        return styles["light"]
      default:
        return styles["dark"]
    }
  }

  const menuLinks = () => (
    <>
      {menuItems.map((item, index) => (
        <Link 
          key={index}
          className={classNames(styles["nav-link"], navStyleClassName())} 
          href={item.link}
        >
          <span className={classNames(styles["link-text"])}>
            {item.title}
          </span>
        </Link>
      ))}
    </>
  )

  return (
    <header className={styles.header}>
      <nav className={classNames(
        styles["nav-bar"], 
        navStyleClassName()
      )}>
        <div className={styles.container}>
          <Link href="/">
            <Image
              priority
              src={logo.path}
              sizes={logo.sizes}
              style={{
                width: '100%',
                height: 'auto'
              }}
              height={logo.height}
              width={logo.width}
              alt={logo.alt}
            />
          </Link>
          <div className={styles["nav-items-container-horizontal"]}>
            { menuLinks() }
          </div>
          {children !== undefined && children !== null &&
            <div className={styles["children-container"]}>
              {children}
            </div>
          }
          <div 
            className={classNames(styles["nav-menu"], navStyleClassName())} 
            onClick={toggleMenu} 
          />
        </div>
        {isMenuOpen &&
          <div className={styles["nav-vertical-wrapper"]} onClick={toggleMenu}>
            <div className={styles["nav-items-container-vertical"]}>
              { menuLinks() }
            </div>
          </div>
        }
      </nav>
    </header>
  )
}
